module.exports = __webpack_public_path__ + "img/USNBT.48c45252.svg";